"use strict";
import { PLAYWRIGHT_CONNECT_ADDRESS } from "components/Web3Provider/constants";
import { wagmiConfig } from "components/Web3Provider/wagmiConfig";
import { isPlaywrightEnv } from "utilities/src/environment/env";
import { isAddress } from "viem";
import { connect } from "wagmi/actions";
import { injected, mock } from "wagmi/connectors";
if (window.Cypress?.eagerlyConnect) {
  connect(wagmiConfig, { connector: injected() });
}
export function setupWagmiAutoConnect() {
  if (window.Cypress?.eagerlyConnect) {
    connect(wagmiConfig, { connector: injected() });
  }
  const isEagerlyConnect = !window.location.search.includes("eagerlyConnect=false");
  const eagerlyConnectAddress = window.location.search.includes("eagerlyConnectAddress=") ? window.location.search.split("eagerlyConnectAddress=")[1] : void 0;
  if (isPlaywrightEnv() && isEagerlyConnect) {
    setTimeout(() => {
      connect(wagmiConfig, {
        connector: mock({
          features: {},
          accounts: [
            eagerlyConnectAddress && isAddress(eagerlyConnectAddress) ? eagerlyConnectAddress : PLAYWRIGHT_CONNECT_ADDRESS
          ]
        })
      });
    }, 1);
  }
}
